import { createApi } from "@reduxjs/toolkit/query/react";
import { appBaseQuery } from "../../services/baseQuery";
import { buildPagedListUrl } from "../../services/queryParams";

export const operationApi = createApi({
  reducerPath: "operationApi",
  baseQuery: appBaseQuery,
  tagTypes: ["Operation"],
  endpoints: (builder) => ({
    getOperations: builder.query({
      query: (params = {}) => buildPagedListUrl("operation/", params),
      providesTags: ["Operation"],
    }),
    addOperation: builder.mutation({
      query: (newOperation) => ({
        url: "operation/",
        method: "POST",
        body: newOperation,
      }),
      invalidatesTags: ["Operation"],
    }),
    updateOperation: builder.mutation({
      query: ({ uid, ...updatedOperation }) => ({
        url: `operation/${uid}`,
        method: "PUT",
        body: updatedOperation,
      }),
      invalidatesTags: ["Operation"],
    }),
    deleteOperation: builder.mutation({
      query: (uid) => ({
        url: `operation/${uid}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Operation"],
    }),
  }),
});

export const {
  useGetOperationsQuery,
  useLazyGetOperationsQuery,
  useAddOperationMutation,
  useUpdateOperationMutation,
  useDeleteOperationMutation,
} = operationApi;
